import { render } from "./attest-stage.vue?vue&type=template&id=d16bff82"
import script from "./attest-stage.vue?vue&type=script&lang=js"
export * from "./attest-stage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__